import * as types from "./mutation-types";
import EventBus from "../../../shared/utils/event_bus";

export default {
  [types.CLEAR_ACTIVE_FILTERS](state) {
    state.filters.forEach((item) => {
      if (item.hasOwnProperty("active")) {
        item.active = [];
      }
      if (item.type === "range") {
        item.from = item.min;
        item.to = item.max;
        item.touched = false;
      }
      if (item.hasOwnProperty("value") && item.type === "string") {
        item.value = "";
      }
    });
    EventBus.$emit("MARKETPLACE_CLEAR_ACTIVE_FILTERS");
  },

  [types.SET_LIST_MODE](state) {
    state.list_mode = !state.list_mode;
  },

  [types.SET_PARTNER_INFO](state, payload) {
    state.partner_info = payload;
  },

  [types.SET_PARTNER_SEARCH_TERM](state, payload) {
    state.partnerSearchTerm = payload;
  },

  [types.SET_MARKETPLACE](state, payload) {
    const shuffled_payload = payload.sort(() => Math.random() - 0.5);
    state.products = state.products.concat(shuffled_payload);
    state.page++;
  },

  [types.SET_MARKETPLACE_BY_FILTERS](state, payload) {
    const shuffled_payload = payload.sort(() => Math.random() - 0.5);
    state.products = shuffled_payload;
  },

  [types.SET_MARKETPLACE_SEARCH](state, payload) {
    state.query = payload;
  },

  [types.SET_MARKETPLACE_SEARCH_LIST](state, payload) {
    state.products = payload;
    state.page = 1;

    if (payload.length == 0) {
      state.loader = true;
    } else {
      state.loader = false;
    }
  },

  [types.SET_MARKETPLACE_SEARCH_RESET](state, payload) {
    state.page = payload;
    state.products = [];
  },

  [types.SET_MARKETPLACE_FAVORITE](state, payload) {
    state.favorite = payload;
  },

  [types.SET_MARKETPLACE_RESET](state, payload) {
    state.page = 1;
    state.query = "";
    state.products = [];
    // state.favorite = payload;
  },

  [types.SET_MARKETPLACE_FAVORITE_LIST](state, payload) {
    state.favorite_marketplace = payload;
    // console.log("ID", state.ids_favorite);
    //state.query = payload;
  },

  [types.SET_QTD_FILTER](state, payload) {
    // console.log("Payload", payload)
    state.qtd_filter = state.qtd_filter + payload;
  },

  [types.SET_REMOVER_FILTER](state, payload) {
    state.qtd_filter = state.qtd_filter - payload;
  },

  [types.SET_RANGE_FILTER](state, { name, value }) {
    let index = state.filters.findIndex((item) => item.name === name);
    state.filters[index].from = value.from;
    state.filters[index].to = value.to;
    state.filters[index].touched = true;
  },

  [types.SET_TOGGLE_FILTER](state, { name, value }) {
    let index = state.filters.findIndex((item) => item.name === name);
    let filter = state.filters[index];
    if (filter.type === "tagbox") {
      if (filter.active.includes(value)) {
        filter.active.splice(
          filter.active.findIndex((item) => item === value),
          1
        );
        return;
      }
      filter.active.push(value);
    }
    if (filter.type === "select") {
      if (filter.active.includes(value)) {
        filter.active = [];
        return;
      }
      filter.active = [];
      filter.active.push(value);
    }
  },

  [types.SET_SEARCH_CHARS](state, payload) {
    let index = state.filters.findIndex((item) => item.name === "Caracteres");
    state.filters[index].value = payload.length
      ? payload.toUpperCase()
      : payload;
    state.filters[index].touched = true;
  },

  [types.CLEAR_MARKETPLACE](state) {
    state.products = [];
  },

  [types.CLEAR_FILTER](state, filter, active) {
    let selectedFilter = state.filters.find(
      (item) => item.slug === filter.slug
    );
    switch (filter.type) {
      case "range":
        selectedFilter.from = selectedFilter.min;
        selectedFilter.to = selectedFilter.max;
        selectedFilter.touched = false;
        break;
      case "tagbox":
      case "select":
        selectedFilter.active.splice(
          selectedFilter.active.findIndex((item) => item === active),
          1
        );
        break;
      default:
        console.error("clear filter: filter type not recognised");
        break;
    }
  },
};
